import React from 'react';
import CollectionDatasetRow from './CollectionDatasetRow';

const CollectionDatasetsTableRows = ({
  category,
  code,
  className,
  items,
  onCheckBoxClick,
  columns,
  theme,
}) => (
  items.map((item, index) => (
    <CollectionDatasetRow
      className={className}
      key={`collection_datasets_table_row_${item.id}`}
      category={category}
      code={code}
      dataset={item}
      onCheckBoxClick={onCheckBoxClick}
      upward={index > 4}
      columns={columns}
      theme={theme}
    />
  ))
);

export default CollectionDatasetsTableRows;
